import { LoadingSpinner } from "@shared/components/LoadingSpinner";
import theme from "@shared/utils/themeColors";
import { formatDistanceToNow } from "date-fns";
import { Lock } from "lucide-react";
import React from "react";
import { Link } from "react-router-dom";
import { Space } from "../types/space.types";

interface PopularSpacesProps {
  spaces: Space[];
  isLoading: boolean;
}

/**
 * Component that displays popular spaces sorted by interactions
 */
const PopularSpaces: React.FC<PopularSpacesProps> = ({ spaces, isLoading }) => {
  return (
    <div className={`${theme.bg.primary} p-4 rounded-xl`}>
      <div className={`text-xs font-semibold ${theme.text.inactive} uppercase mb-4`}>
        Popular Spaces
      </div>

      {isLoading ? (
        <div className="flex justify-center py-4">
          <LoadingSpinner size="md" />
        </div>
      ) : (
        <>
          <ul className="space-y-3">
            {spaces.map((space) => (
              <li key={space.id}>
                <div className="text-sm mb-1">
                  <Link
                    className={`font-medium ${theme.text.primary} hover:text-gray-900 dark:hover:text-white`}
                    to={`/spaces/${space.id}`}
                  >
                    {space.title}
                  </Link>
                  {space.isPrivate && (
                    <Lock size={12} className="inline-block ml-1 text-violet-500" />
                  )}
                </div>
                <div className={`text-xs ${theme.text.muted}`}>
                  <Link
                    className={`font-medium ${theme.text.brand} ${theme.text.brandHover}`}
                    to={`/community/profile/${space.author?.id || ""}`}
                  >
                    {space.author?.name || "Anonymous"}
                  </Link>{" "}
                  ·{" "}
                  {space.createdAt && typeof space.createdAt !== "string"
                    ? formatDistanceToNow(new Date(space.createdAt.toDate()), {
                      addSuffix: true,
                    })
                    : "recently"}{" "}
                  · {space.commentCount || 0} comments
                </div>
              </li>
            ))}
          </ul>
          <div className="mt-4">
            <Link to="/spaces">
              <button className="btn-sm w-full bg-white dark:bg-gray-800 border-gray-200 dark:border-gray-700/60 hover:border-gray-300 dark:hover:border-gray-600 text-gray-800 dark:text-gray-300">
                View All
              </button>
            </Link>
          </div>
        </>
      )}
    </div>
  );
};

export default PopularSpaces;
